export class AwsNativePitrBackupResourceType {
    'resourceType';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType & string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsNativePitrBackupResourceType.attributeTypeMap;
    }
    constructor() {
    }
}
